// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1dTLs","alert":"SettungsInbox_alert__UkGVL"};